import { tokensCss } from '@fd/design-tokens';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { parseHash } from './app/router.tsx';
import { installScrollMemory } from './app/scroll-memory.ts';
import './styles/global.css';
import './styles/components.css';
import './styles/dashboard.css';
import './styles/palette.css';
import './styles/transactions.css';
import './styles/layout.css';
import './styles/studio.css';
import './styles/spotlight.css';
import './styles/omgloft.css';

// Design tokens become CSS variables once, before the first render.
const style = document.createElement('style');
style.dataset.tokens = '';
style.textContent = tokensCss();
document.head.prepend(style);

// Back and forward return to where each page was scrolled (the router's pages, not its details).
installScrollMemory((hash) => parseHash(hash).page);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
